// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2sEYJ","header":"PatientQuestionnaire_header__pQvzF","info":"PatientQuestionnaire_info__1OF_C"};